import { render } from "./firmlist.vue?vue&type=template&id=095a27e8&scoped=true"
import script from "./firmlist.vue?vue&type=script&lang=js"
export * from "./firmlist.vue?vue&type=script&lang=js"

import "./firmlist.vue?vue&type=style&index=0&id=095a27e8&scoped=true&lang=scss"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095a27e8"]])

export default __exports__